/* eslint-disable import/no-extraneous-dependencies */
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import store from '../store';

// import { useRouterHistory } from 'react-router';
// import { createHistory } from 'history';

// const history = useRouterHistory(createHistory)({ basename: '/' });
const history = syncHistoryWithStore(browserHistory, store)

export default history;



// WEBPACK FOOTER //
// ./src/routes/history.js